'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import cl from 'clsx/lite';
import { forwardRef } from 'react';
import { useMergeRefs } from '../../utilities/hooks/use-merge-refs/use-merge-refs.js';
import '@digdir/designsystemet-web';
import { useSynchronizedAnimation } from '../../utilities/hooks/use-synchronized-animation/use-synchronized-animation.js';
import '../../utilities/roving-focus/roving-focus-item.js';
import '../../utilities/roving-focus/roving-focus-root.js';

/**
 * Spinner component used for indicating busy or indeterminate loading.
 *
 * @example
 * <Spinner aria-label='Loading users...' />
 */
const Spinner = forwardRef(function Spinner({ 'aria-label': ariaLabel, className, ...rest }, ref) {
    const svgRef = useSynchronizedAnimation('ds-spinner-rotate-animation');
    const strokeRef = useSynchronizedAnimation('ds-spinner-stroke-animation');
    const mergedRefs = useMergeRefs([svgRef, ref]);
    return (jsxs("svg", { "aria-label": ariaLabel, className: cl('ds-spinner', className), ref: mergedRefs, role: 'img', viewBox: '0 0 50 50', ...rest, children: [jsx("circle", { className: cl('ds-spinner__background'), cx: '25', cy: '25', r: '20', fill: 'none', strokeWidth: '5' }), jsx("circle", { className: cl(`ds-spinner__circle`), cx: '25', cy: '25', r: '20', fill: 'none', strokeWidth: '5', ref: strokeRef })] }));
});

export { Spinner };
